import { createContext, useContext } from "react";

import { EventReminderScreenModel } from "./EventReminderScreenModel.ts";

export const EventReminderScreenContext =
  createContext<EventReminderScreenModel>({} as EventReminderScreenModel);

export const useEventReminderScreenContext = () =>
  useContext(EventReminderScreenContext);
